import * as Sentry from '@sentry/react';
import { GetMeQuery } from 'graphql/types';
export const useSentryUserContext = ({
  me
}: GetMeQuery | undefined = {}): void => {
  if (!me) return;
  Sentry.configureScope((scope) => {
    scope.setUser({ id: me?.id, username: me?.loginName });
    scope.setTag('companyKey', me?.companyKey as string);
  });
};
